import { render, staticRenderFns } from "./TaskViewHeaderShare.vue?vue&type=template&id=167e3aa8&scoped=true"
import script from "./TaskViewHeaderShare.vue?vue&type=script&lang=js"
export * from "./TaskViewHeaderShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "167e3aa8",
  null
  
)

export default component.exports